import AttributeCondition, {
  ago,
  fromNow,
  isBinaryOperator,
  isRelativeTimestampOperator,
  isTwoValueOperator,
} from 'cio/app-models/conditions/attribute';
import { SECONDS_IN_DAY } from 'cio/utils/constants';
import convertOperator from 'cio/utils/operators/convert';
import { SerializedLegacyAttributeFilterCondition } from 'cio/types/conditions/legacy-filter';

export default function deserializeAttributeFilter(filter: SerializedLegacyAttributeFilterCondition) {
  let { name, operator, value, value2, within } = filter;
  let attributes: {
    name?: string;
    operator: string;
    timestampValue?: string;
    timeDirection?: string;
    value?: string | null;
    value2?: string;
  } = {
    name,
    operator: convertOperator(operator),
  };

  if (isRelativeTimestampOperator(attributes.operator)) {
    let withinInDays = Math.floor((within as number) / SECONDS_IN_DAY);

    attributes.timestampValue = Math.abs(withinInDays).toString();
    attributes.timeDirection = (within as number) < 0 ? ago : fromNow;
  } else if (isTwoValueOperator(operator)) {
    attributes.value = value;
    attributes.value2 = value2;
  } else if (isBinaryOperator(attributes.operator)) {
    attributes.value = value;
  }

  return AttributeCondition.create(attributes);
}
